// Consente stati intermedi: "", "12", "12,", "12,3", "12,34"
export const moneyRegexIT = /^(?:\d+)?(?:,\d{0,2})?$/;

/** Normalizza stringa con virgola -> numero con punto e 2 decimali
 *  "" -> null, "12"->12.00, "12,"->12.00, "12,3"->12.30, "12,34"->12.34
 */
export function normalizeMoney(s) {
  if (s == null || s === "") return null;
  const fixed = /,$/.test(s) ? s + "00" : s; // gestisci "12," -> "12,00"
  const n = Number(String(fixed).replace(",", "."));
  if (isNaN(n)) return null;
  return Number(n.toFixed(2));
}

/** Numero (o stringa con punto/virgola) -> "xx,yy" per UI */
export function toUiMoney(n) {
  if (n === null || n === undefined || n === "") return "";
  const num = typeof n === "number" ? n : Number(String(n).replace(",", "."));
  if (isNaN(num)) return "";
  return num.toFixed(2).replace(".", ",");
}

/** Clamp percentuale 0..100. "", null, undefined -> null */
export function clampPercent(v) {
  if (v === "" || v === null || v === undefined) return null;
  let n = parseInt(v);
  if (isNaN(n)) return null;
  if (n > 100) n = 100;
  if (n < 0) n = 0;
  return n;
}

/** Sanitizza input monetario in tempo reale:
 *  - trasforma "." -> ","
 *  - rimuove tutto tranne cifre e una sola virgola
 *  - limita a 2 decimali se presenti
 *  NON formatta a 2 decimali (fallo su onBlur o a submit)
 */
export function sanitizeMoneyInput(raw) {
  if (raw == null) return "";
  let v = String(raw);

  // 1) normalizza punto -> virgola
  v = v.replace(/\./g, ",");

  // 2) rimuovi tutto ciò che non è cifra o virgola
  v = v.replace(/[^\d,]/g, "");

  // 3) tieni solo la prima virgola e max 2 decimali
  const firstComma = v.indexOf(",");
  if (firstComma !== -1) {
    const before = v.slice(0, firstComma);
    const after = v.slice(firstComma + 1).replace(/,/g, "");
    v = `${before},${after.slice(0, 2)}`;
  }

  return v;
}
